module.exports = __webpack_public_path__ + "static/img/2.b6a135b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/2.png
// module id = H5W1
// module chunks = 1 3